import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const mutation = gql`
mutation CreateSkillsDirectory($model: RequestTypeDirectoryInput!) {
  createRequestTypeDirectory(input: $model){
    id
    name
    description
    team {
      id
      name
    }
    requestTypes {
      priority
      requestType {
        id
        name
        active
        description
      }
    }
    priority
  }
}`;

function createSkillsDirectory(model) {
  return apollo.client.mutate({
    mutation,
    variables: {
      model,
    },
  }).then((res) => res.data.createRequestTypeDirectory);
}

export default createSkillsDirectory;
